import { FccManualPoolingOffReason } from '@backoffice-frontend/graphql'

export const manualPoolingOffReasons = [
  FccManualPoolingOffReason.ShortBreak,
  FccManualPoolingOffReason.AdTestDrive,
  FccManualPoolingOffReason.Troubleshooting,
  FccManualPoolingOffReason.Other,
]
